module.exports = __webpack_public_path__ + "static/media/donbosco23.5d881712.jpg";